var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.133,
    height: 54.715,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2476"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2177"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2166"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2154"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2104",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1968"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2531",
    d: "M14.077 12.276s8.182-6.568 17.314-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2533",
    d: "M11.464 2.244l1.586 3.845H9.944l1.52 3.954",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2534",
    d: "M5.267 16.844l-3.478-4.988 4.254-1.015-4.52-6.673",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2535",
    d: "M36.978.875L30.65 14.249h6.328L32.2 24.809l16.058-12.5h-7.1L47.476.874z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2536",
    d: "M7.062 28.275a10.118 10.118 0 007.262-8.479"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2537",
    d: "M14.452 19.999s6.54 7.847 25.9 7.818"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2538",
    d: "M39.455 19.798a6.523 6.523 0 011.421 3.889v15.35l-1.027 3.923"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2539",
    d: "M40.877 38.843a4.586 4.586 0 003.993-.948 5.452 5.452 0 002.109-5.5 4.494 4.494 0 00-2.686-3.881 8.234 8.234 0 00-3.416-.4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2541",
    d: "M7.061 38.843a4.586 4.586 0 01-3.993-.948 5.451 5.451 0 01-2.109-5.5 4.493 4.493 0 012.686-3.881 8.233 8.233 0 013.415-.4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2542",
    d: "M19.445 43.771a6.473 6.473 0 019.307 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2543",
    d: "M31.41 32.617l-2.8 2.633 4.149 1.461",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2544",
    d: "M16.898 32.617l2.8 2.633-4.149 1.461",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2545",
    d: "M7.061 32.481a3 3 0 00-3.278 1.452"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2546",
    d: "M40.876 32.481a3 3 0 013.278 1.452"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2547",
    d: "M38.437 45.962a18.555 18.555 0 01-11.011 7.429 16.77 16.77 0 01-14.555-3.57c-2.094-1.856-4.972-6.618-5.2-8.713s0-16.8 0-16.8a9.5 9.5 0 011.1-4.572 33.009 33.009 0 013.139-5.131"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.2a513933251a699909b14ffed645d244.svg";
export { ForwardRef as ReactComponent };